import React from 'react';

import Footer from '../components/Footer';
import '../App.css';

const TugBargeOperations = () => {
  return (
    <div>
    

      {/* Cover Section */}
      <div className="service-cover">
        <img src="/images/tugboat.webp" alt="Tug & Barge Operations" className="service-cover-image" />
        <div className="service-cover-text">
          <h1>Tug & Barge Operations</h1>
          <p>Efficient | Reliable | Maritime Logistics</p>
        </div>
      </div>

      {/* Main Content */}
      <section className="service-section container">
        <div className="intro-text">
          <h2>Overview</h2>
          <p>
            Our Tug & Barge Operations provide seamless heavy cargo transportation and maneuvering solutions for ports, offshore projects, and coastal logistics. 
            With an experienced crew and state-of-the-art fleet, we ensure safe and timely delivery of maritime freight even in the most challenging environments.
          </p>
        </div>

        <div className="service-grid">
          {/* Tug Services */}
          <div className="service-card">
            <img src="/images/tug-services.webp" alt="Tug Boat" className="service-card-image" />
            <div className="service-card-content">
              <h3>Tug Services</h3>
              <ul>
                <li>Harbor towing and escort services</li>
                <li>Offshore towing & positioning</li>
                <li>Emergency response & salvage readiness</li>
                <li>Berthing and unberthing support</li>
              </ul>
            </div>
          </div>

          {/* Barge Operations */}
          <div className="service-card">
            <img src="/images/barge.webp" alt="Barge Operations" className="service-card-image" />
            <div className="service-card-content">
              <h3>Barge Operations</h3>
              <ul>
                <li>Heavy cargo and equipment transport</li>
                <li>Bulk and containerized freight handling</li>
                <li>Custom-built barge logistics solutions</li>
                <li>Inland and coastal barge services</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default TugBargeOperations;
